import React from 'react'
import PropTypes from 'prop-types'

function CropperOverlay({ canvas, cropper }) {
  return (
    <svg
      className="cropper-overlay"
      viewBox={`0 0 ${canvas.width} ${canvas.height}`}
      preserveAspectRatio="none"
      style={{
        top: `${canvas.y}px`,
        left: `${canvas.x}px`,
        width: `${canvas.width}px`,
        height: `${canvas.height}px`
      }}
    >
      <defs>
        <mask id="hole">
          <rect
            width="100%"
            height="100%"
            fill="rgb(123, 123, 123)"
          />
          <rect
            x={Math.ceil(cropper.x - canvas.x)}
            y={Math.ceil(cropper.y - canvas.y)}
            width={Math.floor(cropper.width)}
            height={Math.floor(cropper.height)}
            fill="black"
          />
        </mask>
      </defs>
      <rect
        fill="black"
        width="100%"
        height="100%"
        mask="url(#hole)"
      />
    </svg>
  )
}

CropperOverlay.propTypes = {
  canvas: PropTypes.shape({
    y: PropTypes.number,
    x: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired,
  cropper: PropTypes.shape({
    y: PropTypes.number,
    x: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired
}

export default CropperOverlay
